var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M636.627 138.996L593.583 224.994C585.719 240.705 566.661 247.137 550.885 239.406L479.901 200.598L480 480C480.006 497.67 465.684 512 448.012 512H191.989C174.317 512 159.995 497.67 160 480L160.1 200.598L89.116 239.406C73.34 247.137 54.282 240.705 46.418 224.994L3.374 138.996C-4.537 123.193 1.946 103.846 17.78 96L203.465 0C223.59 27.75 268.09 47.25 319.965 47.25C319.977 47.25 319.989 47.248 320 47.248S320.024 47.25 320.036 47.25C371.911 47.25 416.411 27.75 436.536 0L622.221 96C638.055 103.846 644.538 123.193 636.627 138.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.4301b99886d8048d2c7df1f5064745ac.svg";
export { ForwardRef as ReactComponent };